import React, { useEffect, useState } from "react"
import { useNavigate, } from "react-router-dom";
import { SubMenu } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";

import { SchoolPages, Subjects, NavigationBar } from "../../helper";
import { OverViewMarking, Item } from "./";
import { setClassId, setClassName, setSubjectName, setYear } from "../../store/markingSlice";
import { setSelect } from "../../store/stylesSlice";

import ClassHomeNavIcon from "../../assets/images/ClassHomeNavIcon.svg"
import ClassLogo from "../../assets/images/Class.svg"
import MathsLogo from "../../assets/images/Maths.svg"
import WritingLogo from "../../assets/images/Writing.svg"
import ReadingLogo from "../../assets/images/Reading.svg"
import ScienceLogo from "../../assets/images/Science.svg"
import PELogo from "../../assets/images/PE.svg"
import ClassHomeIconSelected from "../../assets/images/ClassHomeSelected.svg"
import ClassLogoselected from "../../assets/images/ClassSelected.svg"
import MathsLogoSelected from "../../assets/images/MathsLogoSelected.svg"
import WritingLogoSelected from "../../assets/images/WritingSelected.svg"
import ReadingLogoSelected from "../../assets/images/ReadingLogoSelected.svg"
import ScienceLogoSelected from "../../assets/images/ScienceSelected.svg"
import PELogoSelected from "../../assets/images/PE_Selected.svg"

const SubNav = (props) => {
  const { className, year, subject, classId, i, handleNavSelect, setMyClasses, selectedClass, setSelectedClass, isCollapsed, setIsCollapsed } = props;
  const url = window.location.href; // Get the current URL
  const isClassHomeEndPoint = url.split("/").pop();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectTab, setSelectTab] = useState(false)
  const subOverviewId = useSelector(state => state.marking.subjectName);
  const select = useSelector((state) => state.styleData.select)
  const myClass = select === NavigationBar.MyClasses;
  let assessWriting = false;
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(selectedClass)
  let subjectImage = Subjects.Empty;
  useEffect(() => {
    setIsSubMenuOpen(selectedClass)
  }, [selectedClass])

  const goToClasses = (key) => {
    handleNavSelect(key);
    setSelectedClass(key)
    dispatch(setClassId(classId));
    dispatch(setClassName(className));
    dispatch(setYear(year));
    navigate(SchoolPages.classHome)
    dispatch(setSubjectName(Subjects.Empty));
    setSelectTab(true);
    if (key === i) {
      setIsSubMenuOpen(!isSubMenuOpen);
    }
    dispatch(setSelect(NavigationBar.MyClasses))
  };

  const selectSubjectIcon = (name) => {
    return name === Subjects.Maths ? (assessWriting = false, (subOverviewId === Subjects.Maths && myClass) ? MathsLogoSelected : MathsLogo) : (name === Subjects.Reading) ? (assessWriting = false, (subOverviewId === Subjects.Reading && myClass) ? ReadingLogoSelected : ReadingLogo) : (name === Subjects.Writing) ? (assessWriting = true, (subOverviewId === Subjects.Writing && myClass) ? WritingLogoSelected : WritingLogo) : (name === Subjects.Science) ? (assessWriting = false, (subOverviewId === Subjects.Science && myClass) ? ScienceLogoSelected : ScienceLogo) : (name === Subjects.PE) ? (assessWriting = false, (subOverviewId === Subjects.PE && myClass) ? PELogoSelected : PELogo) : Subjects.Empty;
  }

  return (
    <>
      <SubMenu label={className} onClick={() => { goToClasses(i) }} icon={<img src={selectedClass ? ClassLogoselected : ClassLogo} alt="ClassLogo" />} style={{ color: selectedClass ? "#FFA177" : "#FFF" }} open={(selectedClass && isSubMenuOpen)}> {/* classname */}
        {(selectedClass && isSubMenuOpen) ? <>
          <Item title="Class Home" icon={<img className="classHomeNav" src={(selectedClass && selectTab || (isClassHomeEndPoint==="ClassHome")) ? ClassHomeIconSelected : ClassHomeNavIcon} alt="ClassHomeNavIcon" />} to={`${SchoolPages.classHome}`} setMyClasses={setMyClasses}
            overRideSelected={selectedClass}
            classId={classId} className={className} year={year}
            selectTab={selectTab}
            setSelectTab={setSelectTab}
            setSelectedClass={setSelectedClass}
            i={i}
            isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}
          />
          {subject?.map((ele, index) => {
            subjectImage = selectSubjectIcon(ele.name);
            return (<OverViewMarking {...ele} subject={subject} classId={classId} className={className} year={year} i={`${i}-S-${index}`} key={`${i}-S-${index}`} handleNavSelect={handleNavSelect} subjectImage={subjectImage} assessWriting={assessWriting} setSelectedClass={setSelectedClass} selectTab={selectTab} setSelectTab={setSelectTab} iOne={i} />)
          })}</> : ""}
      </SubMenu>
    </>
  )
};


export { SubNav };